/*
 * Greens Club: add-to-cart links that stay on the page.
 *
 * Any link shaped like one of these adds the variant through the AJAX cart and
 * opens the cart drawer instead of navigating away:
 *   /cart/add?id=<variant>&quantity=<n>
 *   /discount/<CODE>?redirect=/cart/add?id=<variant>&quantity=<n>
 * The href itself is left intact, so the link still works if this script fails.
 */
(() => {
  function parseCartLink(anchor) {
    const url = new URL(anchor.href, window.location.origin);
    if (url.origin !== window.location.origin) return null;

    let code = null;
    let addUrl = url;
    const discountMatch = url.pathname.match(/^\/discount\/([^/]+)$/);
    if (discountMatch) {
      const redirect = url.searchParams.get('redirect');
      if (!redirect) return null;
      code = decodeURIComponent(discountMatch[1]);
      addUrl = new URL(redirect, window.location.origin);
    }

    if (addUrl.pathname !== '/cart/add') return null;
    const id = addUrl.searchParams.get('id');
    if (!id) return null;
    return { code, id, quantity: Number(addUrl.searchParams.get('quantity')) || 1 };
  }

  async function addFromLink(anchor, { code, id, quantity }) {
    const cartDrawer = document.querySelector('cart-drawer');
    anchor.setAttribute('aria-disabled', 'true');
    anchor.classList.add('loading');

    try {
      // Visiting /discount/<CODE> sets the discount cookie that the cart and checkout read.
      if (code) await fetch(`/discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' });

      const body = { items: [{ id: Number(id), quantity }] };
      if (cartDrawer) {
        body.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || 'Add to cart failed');

      if (!cartDrawer) {
        window.location = window.routes.cart_url;
        return;
      }
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gc-cart-link', productVariantId: id, cartData: state });
      // The drawer markup sits in a deferred <template> until first opened.
      window.loadTemplateContent(cartDrawer);
      cartDrawer.renderContents(state, true);
      cartDrawer.classList.remove('is-empty');
      setTimeout(() => cartDrawer.open(anchor));
    } catch (error) {
      console.error(error);
      window.location = anchor.href;
    } finally {
      anchor.removeAttribute('aria-disabled');
      anchor.classList.remove('loading');
    }
  }

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a[href]');
    if (!anchor || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey) return;
    const link = parseCartLink(anchor);
    if (!link) return;
    event.preventDefault();
    addFromLink(anchor, link);
  });
})();
